export default __webpack_public_path__ + "static/media/SafePal.ff532d93.svg";